import { useEffect, useState } from 'react';
import { getAssetPath } from '../components/Icons';

const assetPathCache = new Map<string, string>();

export const useAssetPath = (relativePath: string): string => {
  const fallbackPath = relativePath ? `/assets/${relativePath}` : '';
  const [assetPath, setAssetPath] = useState(
    () => (relativePath && assetPathCache.get(relativePath)) || fallbackPath,
  );

  useEffect(() => {
    if (!relativePath) {
      setAssetPath('');
      return;
    }

    const cachedPath = assetPathCache.get(relativePath);
    if (cachedPath) {
      setAssetPath(cachedPath);
      return;
    }

    setAssetPath(`/assets/${relativePath}`);

    let cancelled = false;

    void getAssetPath(relativePath).then((url) => {
      assetPathCache.set(relativePath, url);
      if (!cancelled) {
        setAssetPath(url);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [relativePath]);

  return assetPath;
};
